import { IdentityUserAri } from '@atlassian/ari';
import type { PreloadedQuery } from 'react-relay';
import type { RouteResource } from 'react-resource-router';

import { AggListQuery, type AggListQueryType } from '@townsquare/agg-list/query';
import { createRelayResource } from '@townsquare/relay-utils';
import { AggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { HomeResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

const EDGES: string[] = [
	'user_favorited_confluence_page',
	'user_favorited_confluence_blogpost',
	'user_favorited_confluence_whiteboard',
	'user_favorited_confluence_database',
];

const createCypherQuery = (accountId: string) => {
	const userAri = IdentityUserAri.create({ userId: accountId }).toString();

	const edges = fg('townsquare_item_star_actions') ? EDGES.concat('user_favorited_townsquare_project') : EDGES;

	const edgeList = edges.join('|');

	return `MATCH (user: IdentityUser {ari: '${userAri}'})-[rel:${edgeList}]->(entity) RETURN entity ORDER BY rel.createdAt DESC`;
};

export const starredFeedResource: RouteResource<PreloadedQuery<AggListQueryType>> =
	createRelayResource<AggListQueryType>({
		getQuery: (_, resourceContext) => {
			const context = resourceContext as HomeResourceContext;
			const accountId = context.user.accountId;

			const cypherQuery = createCypherQuery(accountId);

			return {
				environment: AggRelayEnvironment,
				query: AggListQuery,
				variables: {
					cypherQuery,
					queryContext: `ari:cloud:platform::org/${context?.orgId}`,
					isEnabled: !!context?.orgId,
					first: fg('townsquare_starred_workarounds') ? 250 : 100,
				},
			};
		},
	});
